import { NATIVE_CLASS_PROBS_PROVIDERS } from '@/shared/domain/taskTypes';

/**
 * Flatten `useCommercialModels().availableProviders` into Retrieval Agent
 * provider dropdown items. Map keys are ModelProvider values (`openai`, …);
 * `provider_type` is vendor|cloud and must not be sent as `agent_model.provider`.
 * Classification-only decision-model providers (TypeSafe AI's Jev) cannot
 * generate text, so their models are never offered as the agent model.
 */
export function providerModelItems(availableProviders) {
    const items = [];
    Object.entries(availableProviders || {}).forEach(([provider, info]) => {
        if (NATIVE_CLASS_PROBS_PROVIDERS.includes(provider)) return;
        (info?.models || []).forEach((model) => {
            if (!model?.id) return;
            items.push({ id: model.id, provider, label: model.id });
        });
    });
    const recommendedIndex = items.findIndex((item) => /gpt-4o/i.test(item.id));
    const rec = recommendedIndex >= 0 ? recommendedIndex : items.length ? 0 : -1;
    return items.map((item, index) => ({
        ...item,
        recommended: index === rec,
        label: index === rec ? `${item.id} (Recommended)` : item.id,
    }));
}

export function formatFileSize(bytes) {
    if (!Number.isFinite(bytes) || bytes < 0) return '';
    if (bytes < 1024) return `${bytes} B`;
    const mb = bytes / (1024 * 1024);
    if (mb >= 1) return `${mb.toFixed(1)} MB`;
    return `${(bytes / 1024).toFixed(1)} KB`;
}
